import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import UseCases from "@/components/UseCases";
import Newsletter from "@/components/Newsletter";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WorkflowVisualization from "@/components/WorkflowVisualization";
import { useEffect } from "react";
import { useToast } from "@/components/ui/use-toast";

const Index = () => {
  const { toast } = useToast();
  
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a');
      
      if (!anchor) return;
      
      if (anchor.hash && anchor.hash.length > 0) {
        e.preventDefault();
        const targetElement = document.querySelector(anchor.hash);
        
        if (targetElement) {
          window.scrollTo({
            top: targetElement.getBoundingClientRect().top + window.scrollY - 100,
            behavior: 'smooth'
          });
        }
      }
    };

    document.addEventListener('click', handleAnchorClick);
    
    return () => {
      document.removeEventListener('click', handleAnchorClick);
    };
  }, []);

  const handleNewsletterSignup = async (email: string) => {
    console.log("Beta signup email:", email);
    
    try {
      // Using FormSubmit with proper configuration
      await fetch("https://formsubmit.co/ajax/beta@swifquery.com", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          email: email,
          _subject: "New Beta Signup Request",
          _template: "table",
          message: `${email} has requested to join the beta program.`
        }),
      });
      
      toast({
        title: "Successfully signed up!",
        description: "Thank you for joining our beta. We'll be in touch soon.",
        duration: 3000,
      });
      
      return Promise.resolve();
    } catch (error) {
      console.error("Error:", error);
      toast({
        title: "Submission may have failed",
        description: "There might have been a problem with your signup. If you don't hear back from us, please try again or contact us directly.",
        variant: "destructive",
        duration: 5000,
      });
      return Promise.reject(error);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main>
        <Hero />
        <WorkflowVisualization />
        <Features />
        <UseCases />
        <Newsletter 
          onEmailSubmit={handleNewsletterSignup}
        />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
